import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  HostBinding,
  ChangeDetectorRef,
  Inject
} from "@angular/core";

import {PlanningViewSettingsJobsModel} from "../../../models/planning-view-settings.model";
import {JobsGroupByEnum} from "../../../types/jobs-group-by.enum";
import {AddressRequestType} from "../../../../addresses/angular/types/address-request.type";
import {LocationType} from "../../../../commons/types/location.type";
import {SplitSuggestionType} from "../planning-draft-jobs-table-list/planning-draft-jobs-table-list.component";

require('./planning-draft-jobs-table-list-row.scss');
@Component({
  standalone: false,
  selector: 'app-planning-draft-jobs-table-list-row',
  templateUrl: './planning-draft-jobs-table-list-row.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDraftJobsTableListRowComponent {

  @Input() job: any;
  @Input() draft?: any;
  @Input() jobsGroupByType: JobsGroupByEnum;
  @Input() settings: PlanningViewSettingsJobsModel;
  
  @Input() isSelected: boolean;
  @Input() isLocked: boolean;
  @Input() routeIndexes: { index: number, isHighlighted: boolean }[];
  @Input() routeColor: string;
  @Input() isObligatedTimeWindow: boolean;
  
  @Input() query: any;
  @Input() type: AddressRequestType;
  
  @Input() isChild: boolean = false;
  @Input() isGroupExpanded: boolean = false;

  @Output() onToggleSelectedJob = new EventEmitter<{jobIds: string[], isSelected: boolean}>();
  @Output() onViewJob = new EventEmitter<{ jobs?: any[], jobIds?: string[], event?: any }>();
  @Output() onToggleObligateTimeWindow = new EventEmitter<{ jobIds: string[], obligateTimeWindow: boolean }>();
  @Output() onContextMenu = new EventEmitter<{ event: any, job: any }>();
  @Output() onReverseJobSplit = new EventEmitter<{ event: MouseEvent, job: any }>();
  @Output() onGroupExpanded = new EventEmitter<{ id: string, expanded: boolean }>();

  public isShowAddressIconPickup: boolean = false;
  public isShowAddressIconDropoff: boolean = false;
  public SplitSuggestionType = SplitSuggestionType;

  @HostBinding('class.tr-container')
  get hasTrContainerClass() { return true; }

  @HostBinding('class.child-row')
  get hasChildRowClass() { return this.isChild; }

  toggleExpand(event: MouseEvent): void {
    event.stopPropagation();
    this.isGroupExpanded = !this.isGroupExpanded;
    this.onGroupExpanded.emit({id: this.job.id, expanded: this.isGroupExpanded});
  }

  trackByJobId(_: number, job: any): string | number {
    return job.id;
  }

  isHighQualityAddress(address: any): boolean {
    return !!(address && address.addressResolvingInfo &&
      address.addressResolvingInfo.qualityGroup === "High");
  }

  isValidAddressType(address: any): boolean {
    return !!(address && (address.locationType === LocationType.ACCOUNT ||
      address.locationType === LocationType.DEPOT ||
      address.locationType === LocationType.RESOURCE ||
      address.locationType === LocationType.CUSTOMER));
  }

  onToggleIsShowAddressIconPickup(isShow: boolean) {
    this.isShowAddressIconPickup = isShow;
  }

  onToggleIsShowAddressIconDropoff(isShow: boolean) {
    this.isShowAddressIconDropoff = isShow;
  }
}
